import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/services/guards/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-backend',
    loadChildren: () => import('./admin-backend/admin-backend.module').then( m => m.AdminBackendPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'secret-sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then( m => m.SignUpPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login/:token/:change',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then( m => m.AuthPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'activation',
    loadChildren: () => import('./activation/activation.module').then( m => m.ActivationPageModule)
  },
  {
    path: 'activation/:activated/:token',
    loadChildren: () => import('./activation/activation.module').then( m => m.ActivationPageModule)
  },
  {
    path: 'showroom',
    loadChildren: () => import('./showroom/showroom.module').then( m => m.ShowroomPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'analytics',
    loadChildren: () => import('./analytics/analytics.module').then( m => m.AnalyticsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'communication',
    loadChildren: () => import('./communication/communication.module').then( m => m.CommunicationPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'content-management',
    loadChildren: () => import('./content-management/content-management.module').then( m => m.ContentManagementPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'preview-room/:showroomId/:token',
    loadChildren: () => import('./invitations/invitations.module').then( m => m.InvitationsPageModule),
    canActivate: [AuthGuard]
  },  
  {
    path: 'shared/:shareId',
    loadChildren: () => import('./invitations/invitations.module').then(m => m.InvitationsPageModule),
  },
  {
    path: 'invitations',
    loadChildren: () => import('./invitations/invitations.module').then( m => m.InvitationsPageModule)
  },
  {
    path: 'invitations/:showroom/:token',
    loadChildren: () => import('./invitations/invitations.module').then( m => m.InvitationsPageModule)
  },
  {
    path: 'feedback/:showroom/:token',
    loadChildren: () => import('./showroom-feedback/feedback.module').then( m => m.FeedbackPageModule)
  },
  {
    path: 'contacts',
    loadChildren: () => import('./contacts/contacts.module').then( m => m.ContactsPageModule)
  },
  {
    path: 'user-settings',
    loadChildren: () => import('./user-setting/user-setting.module').then( m => m.UserSettingPageModule),
    canActivate: [AuthGuard]  
  },
  {
    path: 'company-settings',
    loadChildren: () => import('./company-settings/company-settings.module').then( m => m.CompanySettingsPageModule),
    canActivate: [AuthGuard]  
  },
  {
    path: 'agb',
    loadChildren: () => import('./agb/agb.module').then( m => m.AgbPageModule),
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
